import React, { useState, useEffect } from 'react';
import axios from 'axios';

const SlidePanelForm = ({ isOpen, onClose, onSave, buttonColor, userId, title = 'Main Menu', currentLanguage }) => {
  const [numColumns, setNumColumns] = useState(1);
  const [columnSpacing, setColumnSpacing] = useState(10);
  const [enableOffset, setEnableOffset] = useState(true);
  const [leftOffset, setLeftOffset] = useState(5);
  const [rightOffset, setRightOffset] = useState(0);
  const [topOffset, setTopOffset] = useState(5);

  const [enableVideoEndOffset, setEnableVideoEndOffset] = useState(false);
  const [videoEndLeftOffset, setVideoEndLeftOffset] = useState(0);
  const [videoEndRightOffset, setVideoEndRightOffset] = useState(0);
  const [videoEndTopOffset, setVideoEndTopOffset] = useState(5);

  /////Disable Button Animation///////////////
  const [disableAnimation, setDisableAnimation] = useState(false);

  const [enableVideoEndNavigation, setEnableVideoEndNavigation] = useState(false);
  const [videoEndNavigationMenuId, setVideoEndNavigationMenuId] = useState(null);
  const [availableMenus, setAvailableMenus] = useState([]);

  /////Wheelchair Content Offset///////////////
  const [wheelchairContentOffsetY, setWheelchairContentOffsetY] = useState(20);

  const handleSave = () => {
    const config = {
      numColumns,
      columnSpacing,
      enableOffset,
      leftOffset,
      topOffset,
      rightOffset,
      ////////////
      disableAnimation,
      enableVideoEndOffset,
      videoEndLeftOffset,
      videoEndRightOffset,
      videoEndTopOffset,
      // New fields
      enableVideoEndNavigation,
      videoEndNavigationMenuId,
      wheelchairContentOffsetY,
    };
    console.log("Saving config:", config);
    console.log("Video End Navigation Menu ID:", videoEndNavigationMenuId);
    onSave(config); // Pass the configuration to the parent component
    onClose(); // Close the side panel
  };

  useEffect(() => {
    if (title === 'Main Menu') {
      axios
        .get(`/api/frontend-main-settings/${userId}`)
        .then(response => {
          if (response.data.error) {
          } else {
            console.log("Frontend main menu settings response:", response.data);

            setNumColumns(response.data?.numColumns);
            setEnableOffset(response.data?.enableOffset);
            setColumnSpacing(response.data?.columnSpacing);
            setLeftOffset(response.data?.leftOffset);
            setRightOffset(response.data?.rightOffset);
            setTopOffset(response.data?.topOffset);

            ////////////////////////////////////////////
            setDisableAnimation(response.data?.disableAnimation);

            setEnableVideoEndOffset(response.data?.enableVideoEndOffset);

            setVideoEndLeftOffset(response.data?.videoEndLeftOffset);
            setVideoEndRightOffset(response.data?.videoEndRightOffset);
            setVideoEndTopOffset(response.data?.videoEndTopOffset);

            // Video End Navigation
            setEnableVideoEndNavigation(
              response.data?.enableVideoEndNavigation ?? false,
            );
            setVideoEndNavigationMenuId(
              response.data?.videoEndNavigationMenuId ?? null,
            );

            // Wheelchair Content Offset
            setWheelchairContentOffsetY(
              response.data?.wheelchairContentOffsetY ?? 20,
            );
          }
        })
        .catch(error => {
          console.error('Error fetching menus:', error);
        });

      // Fetch available menus for dropdown (only main menus, no submenus)
      // axios
      //   .get(`/api/menus/${userId}`)
      //   .then((response) => {
      //     if (!response.data.error) {
      //       const userMenuData = response.data.data;
      //       const menus = [];

      //       // Add primary menus ONLY (no submenus)
      //       if (userMenuData?.menus) {
      //         userMenuData.menus.forEach((menu) => {
      //           menus.push({
      //             id: menu._id,
      //             name: menu.name,
      //             type: 'primary'
      //           });
      //         });
      //       }

      //       // Add frontend main menus
      //       if (userMenuData?.frontendmainmenu) {
      //         userMenuData.frontendmainmenu.forEach((menu) => {
      //           menus.push({
      //             id: menu._id,
      //             name: menu.name,
      //             type: 'frontend'
      //           });
      //         });
      //       }

      //       setAvailableMenus(menus);
      //     }
      //   })
      //   .catch((error) => {
      //     console.error("Error fetching available menus:", error);
      //   });


      // Fetch available menus for dropdown (only main menus, no submenus)
      axios
        .get(`/api/primarymenus/${userId}/${currentLanguage}`)
        .then(response => {
          if (response.data.error) {
            console.log('No Menus Found');
          } else {
            console.log("Primary menus response:", response.data);

            // Extract only main menus (without submenus) and map to dropdown format
            const mainMenus = response.data?.data?.menus?.map(menu => ({
              id: menu._id,  // Use _id as the value
              name: menu.name  // Use name for display
            })) || [];

            setAvailableMenus(mainMenus);
            console.log("Available menus for dropdown:", mainMenus);
          }
        })
        .catch(error => {
          console.error('Error fetching menus:', error);
        });

    } else if (title === 'Trivia Topics Settings') {
      axios
        .get(`/api/topic-main-settings/${userId}`)
        .then(response => {
          if (response.data.error) {
          } else {
            setNumColumns(response.data?.numColumns);
            setEnableOffset(response.data?.enableOffset);
            setColumnSpacing(response.data?.columnSpacing);
            setLeftOffset(response.data?.leftOffset);
            setRightOffset(response.data?.rightOffset);
            setTopOffset(response.data?.topOffset);

            ////////////////////////////////////////////
            setDisableAnimation(response.data?.disableAnimation);

            setEnableVideoEndOffset(response.data?.enableVideoEndOffset);

            setVideoEndLeftOffset(response.data?.videoEndLeftOffset);
            setVideoEndRightOffset(response.data?.videoEndRightOffset);
            setVideoEndTopOffset(response.data?.videoEndTopOffset);
          }
        })
        .catch(error => {
          console.error('Error fetching menus:', error);
        });
    }
  }, [userId]);

  return (
    <div className={`side-panel ${isOpen ? 'open' : ''}`}>
      <div className="side-panel-content">
        <h4 style={{ textAlign: 'center' }}>{title}</h4>

        {/* Number of Columns */}
        <div className="row" style={{ marginTop: '31px' }}>
          <div className="col-md-12">
            <span>Number of Button Columns:</span>
            <div className="setting form-group">
              <select
                value={numColumns}
                onChange={e => setNumColumns(e.target.value)}
                className="form-control"
              >
                <option value={''}>Select Button Columns</option>
                <option value={'center-single-row'}>Center Single Row</option>
                <option value={'center-two-buttons-per-row'}>Center 2 Buttons Per Row</option>
                <option value={'left-side-one-button-per-row'}>Left Side One Button Per Row</option>
                <option value={'right-side-one-button-per-row'}>
                  Right Side One Button Per Row
                </option>
                <option value={'unlimited-buttons-center'}>Unlimited Buttons Center (Animation from each side)</option>
                <option value={'unlimited-left-buttons-center'}>Unlimited Left Buttons Center (Animation from left side)</option>
                <option value={'unlimited-right-buttons-center'}>Unlimited Right Buttons Center (Animation from right side)</option>
              </select>
            </div>
          </div>
        </div>

        {/* Button Alignment */}

        {/* <div className="row">
        
          <div className="col-md-12">
          <span>Choose Buttons Alignment</span>
        
        <div  style={{
            marginTop:"10px",
            display: 'inline-flex',
            gap: '26px'
          }} >
        <div className="setting form-group custom-control custom-radio">    
          
            
              <input
              
                type="radio"
                value="left"
                id="left"
                className="custom-control-input"
                checked={buttonAlignment === "left"}
                onChange={() => setButtonAlignment("left")}
              />
              <label className="custom-control-label" htmlFor="left">Left </label>
        </div>
        <div className="setting form-group custom-control custom-radio">
           
              <input
                type="radio"
                value="center"
                className="custom-control-input"
                checked={buttonAlignment === "center"}
                onChange={() => setButtonAlignment("center")}
                id="center"
              />
              
            <label className="custom-control-label" htmlFor="center">Center</label>

        </div>

        <div className="setting form-group custom-control custom-radio">
            
              <input
                type="radio"
                value="right"
                className="custom-control-input"
                checked={buttonAlignment === "right"}
                onChange={() => setButtonAlignment("right")}
                id="right"
              />
              
            <label className="custom-control-label" htmlFor="right">Right </label>
          
        </div>

        </div>


        </div>
        </div> */}

        {/* Column Spacing */}
        <div className="setting form-group">
          <label style={{ fontWeight: 'normal' }}>Button Column Spacing In px:</label>
          <input
            type="number"
            className="form-control"
            value={columnSpacing}
            onChange={e => setColumnSpacing(Number(e.target.value))}
          />
        </div>

        {/* For Disable Animation */}
        <div className="setting form-group custom-control custom-checkbox">
          <input
            type="checkbox"
            checked={disableAnimation}
            onChange={e => setDisableAnimation(e.target.checked)}
            id="disable_animation"
            className="custom-control-input"
          />

          <label className="custom-control-label" htmlFor="disable_animation">
            Disable Button Animation
          </label>
        </div>

        <div className="setting form-group custom-control custom-checkbox">
          <input
            type="checkbox"
            checked={enableOffset}
            onChange={e => setEnableOffset(e.target.checked)}
            id="enable_offset"
            className="custom-control-input"
          />

          <label className="custom-control-label" htmlFor="enable_offset">
            Enable Offset{' '}
          </label>
        </div>

        {enableOffset && (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
            <div className="setting form-group">
              <label style={{ fontWeight: 'normal' }}>Enter Left Offset in %:</label>
              <input
                type="number"
                className="form-control"
                value={leftOffset}
                onChange={e => setLeftOffset(Number(e.target.value))}
              />
            </div>

            <div className="setting form-group">
              <label style={{ fontWeight: 'normal' }}>Enter Right Offset in %:</label>
              <input
                type="number"
                className="form-control"
                value={rightOffset}
                onChange={e => setRightOffset(Number(e.target.value))}
              />
            </div>

            <div className="setting form-group">
              <label style={{ fontWeight: 'normal' }}>Enter Top Offset in %:</label>
              <input
                type="number"
                className="form-control"
                value={topOffset}
                onChange={e => setTopOffset(Number(e.target.value))}
              />
            </div>
          </div>
        )}

        <div className="setting form-group custom-control custom-checkbox">
          <input
            type="checkbox"
            checked={enableVideoEndOffset}
            onChange={e => setEnableVideoEndOffset(e.target.checked)}
            id="enable_video_offset"
            className="custom-control-input"
          />

          <label className="custom-control-label" htmlFor="enable_video_offset">
            Enable Video End Offset{' '}
          </label>
        </div>


        {enableVideoEndOffset && (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
            <div className="setting form-group">
              <label style={{ fontWeight: 'normal' }}>Video End Left Offset %:</label>
              <input
                type="number"
                className="form-control"
                value={videoEndLeftOffset}
                onChange={e => setVideoEndLeftOffset(Number(e.target.value))}
              />
            </div>

            <div className="setting form-group">
              <label style={{ fontWeight: 'normal' }}>Video End Right Offset %:</label>
              <input
                type="number"
                className="form-control"
                value={videoEndRightOffset}
                onChange={e => setVideoEndRightOffset(Number(e.target.value))}
              />
            </div>

            <div className="setting form-group">
              <label style={{ fontWeight: 'normal' }}>Video End Top Offset %:</label>
              <input
                type="number"
                className="form-control"
                value={videoEndTopOffset}
                onChange={e => setVideoEndTopOffset(Number(e.target.value))}
              />
            </div>
          </div>
        )}

        {/* Enable Video End Navigation to Menu */}
        <div className="setting form-group custom-control custom-checkbox">
          <input
            type="checkbox"
            checked={enableVideoEndNavigation}
            onChange={e => setEnableVideoEndNavigation(e.target.checked)}
            id="enable_video_end_navigation"
            className="custom-control-input"
          />

          <label
            className="custom-control-label"
            htmlFor="enable_video_end_navigation"
          >
            Enable Video End Navigation to Menu
          </label>
        </div>

        {enableVideoEndNavigation && (
          <div className="setting form-group">
            <label style={{ fontWeight: "normal" }}>
              Select Menu to Navigate:
            </label>
            <select
              value={videoEndNavigationMenuId || ""}
              onChange={(e) => {
                const selectedId = e.target.value;
                console.log("Selected menu ID:", selectedId);
                setVideoEndNavigationMenuId(selectedId);
              }}
              className="form-control"
            >
              <option value="">Select a menu...</option>
              {availableMenus.map((menu) => (
                <option key={menu.id} value={menu.id}>
                  {menu.name}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Wheelchair Content Offset */}
        <div className="setting form-group">
          <label style={{ fontWeight: "normal" }}>
            Wheelchair Mode Content Offset (%):
          </label>
          <input
            type="number"
            className="form-control"
            value={wheelchairContentOffsetY}
            onChange={(e) => setWheelchairContentOffsetY(Number(e.target.value))}
            min="0"
            max="50"
          />
          <small style={{ color: '#666', display: 'block', marginTop: '4px' }}>
            Content will move down by this percentage when wheelchair mode is active
          </small>
        </div>

        {/* Enable Secondary Menu */}
        {/* <div className="setting">
          <label>
            <input
              type="checkbox"
              checked={enableSecondaryMenu}
              onChange={(e) => setEnableSecondaryMenu(e.target.checked)}
            />
            Enable Secondary Menu
          </label>
        </div> */}

        {/* Save and Cancel Buttons */}
        <div className="actions">
          <button
            type="button"
            onClick={handleSave}
            style={{ backgroundColor: buttonColor?.buttonColor }}
          >
            Save
          </button>
          <button
            type="button"
            onClick={onClose}
            style={{ backgroundColor: buttonColor?.buttonColor }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default SlidePanelForm;
